import "./index.marko?deps"
import { register } from "marko/components"
import component from "./component-browser.js"
register("2+FwbZ61", component)